import React, { useState } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminLogin = () => {
  const { user, loading, login } = useAuth();
  const [email, setEmail] = useState('admin@casaothers.nl');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || '/admin';

  if (loading) return null;
  if (user) return <Navigate to={from} replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || 'Inloggen mislukt');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={styles.page}>
      <form style={styles.card} onSubmit={onSubmit} data-testid="admin-login-form">
        <h1 style={styles.title}>Admin login</h1>
        <p style={styles.subtitle}>Log in om woningen en blogs te beheren.</p>

        <label style={styles.label}>E-mail</label>
        <input
          style={styles.input}
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="username"
          data-testid="admin-login-email"
        />

        <label style={styles.label}>Wachtwoord</label>
        <input
          style={styles.input}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="current-password"
          data-testid="admin-login-password"
        />

        {error && <p style={styles.error} data-testid="admin-login-error">{error}</p>}

        <button
          type="submit"
          style={{ ...styles.btn, ...(submitting ? { opacity: 0.6, cursor: 'not-allowed' } : {}) }}
          disabled={submitting}
          data-testid="admin-login-submit"
        >
          {submitting ? 'Bezig...' : 'Inloggen'}
        </button>
      </form>
    </div>
  );
};

const styles = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#FAF9F6',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem 1.5rem',
  },
  card: {
    width: '100%',
    maxWidth: '420px',
    backgroundColor: 'white',
    border: '1px solid #EAE5DD',
    padding: '3rem 2.5rem',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontFamily: "'Playfair Display', serif",
    fontSize: '2rem',
    color: '#1A1918',
    marginBottom: '0.5rem',
  },
  subtitle: {
    color: '#585755',
    fontSize: '0.95rem',
    marginBottom: '2rem',
  },
  label: {
    color: '#585755',
    fontSize: '0.875rem',
    fontWeight: 500,
    marginBottom: '0.5rem',
    marginTop: '1rem',
  },
  input: {
    padding: '0.75rem',
    border: '1px solid #EAE5DD',
    backgroundColor: '#FAF9F6',
    color: '#1A1918',
    fontSize: '1rem',
    fontFamily: "'Manrope', sans-serif",
    outline: 'none',
  },
  error: {
    color: '#9E3E3E',
    fontSize: '0.875rem',
    margin: '1rem 0 0',
  },
  btn: {
    marginTop: '2rem',
    backgroundColor: '#C5A059',
    color: 'white',
    border: 'none',
    padding: '1rem 2rem',
    fontSize: '0.875rem',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    cursor: 'pointer',
    fontWeight: 500,
    transition: 'all 0.3s ease',
  },
};

export default AdminLogin;
